import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {TranslocoModule} from '@jsverse/transloco';
import {MatProgressSpinner, MatSpinner} from '@angular/material/progress-spinner';
import {CommonModule} from '@angular/common';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-confirm-popup',
  imports: [TranslocoModule, MatDialogModule, MatSpinner, CommonModule, MatProgressSpinner, MatButton],
  templateUrl: './confirm-popup.component.html',
  standalone: true,
  styleUrl: './confirm-popup.component.scss'
})
export class ConfirmPopupComponent {
  loading = false;

  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { collectionItemId: string }
  ) {
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.loading = true;
    this.dialogRef.close(true); // conferma => chiudo passando "true"
  }
}
